<main id="main-content" class="main-content" [formGroup]="form">
  @if (errorList.length > 0) {
    <div class="red-warning">
      <mat-icon class="red-warn-icon">warning</mat-icon>
      <div class="red-warn-text">
        <span class="red-title">Incomplete section</span>
        <span class="red-text">
          The following fields are missing details. Please complete them before proceeding to the next section:
          <ul>
            @for (error of errorList; track error) {
              <li>{{error | titlecase}}</li>
            }
          </ul>
        </span>
      </div>
    </div>
  }
  <div class="subtitle"><span class="red-normal">*</span>Indicates required field</div>
  <h2 class="form-header">1. Fire Report Details</h2>

  <mat-card>
    <div class="title">1a. Report Details</div>
    <div class="bar">&nbsp;</div>

    <div class="whole-line">
      <mat-form-field appearance="outline" class="whole-field">
        <mat-label>Report name</mat-label>
        <input matInput formControlName="report_name" required aria-label="Fire or Complex Name">
        <mat-error>Required Field</mat-error>
      </mat-form-field>
    </div>

    <div class="whole-line">
      <div class="title"><span class="red-normal">*</span>Report type</div>
      <mat-radio-group required formControlName="report_type" class="radio-buttons">
        <mat-radio-button [value]="'Interim'" color="primary" class="radio-button">Interim</mat-radio-button>
        <br>
          <mat-radio-button [value]="'Final'" color="primary">Final</mat-radio-button>
        </mat-radio-group>
      </div>

      @if (report()) {
        <div class="whole-line">
          <div class="data-div">
            <p class="data-title">Fire name</p>
            <p class="data-info">{{reportList()[0].assessment.baer_name ?? "--"}}</p>
          </div>
          <div class="data-div">
            <p class="data-title">Region</p>
            <p class="data-info">{{reportList()[0].assessment.region ?? "--"}}</p>
          </div>
          <div class="data-div">
            <p class="data-title">Forest name</p>
            <p class="data-info">{{reportList()[0].assessment.forest_name ?? "--"}}</p>
          </div>
          <mat-form-field appearance="outline" class="short-field">
            <mat-label>H Code</mat-label>
            <input formControlName="h_code" matInput aria-label="h code" required maxlength="10">
          </mat-form-field>
          <mat-form-field appearance="outline" class="short-field">
            <mat-label class="short-field">Date contained</mat-label>
            <input matInput formControlName="date_contained" required [matDatepicker]="picker1"
              placeholder="MM/dd/yyyy" aria-label="Date Contained">
              <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              <mat-error>Required Field</mat-error>
            </mat-form-field>
            <div class="data-div">
              <p class="data-title">Date of authorization</p>
              <p class="data-info">{{reportList()[0].submission_date | date:"MM/dd/yyyy"}}</p>
            </div>
            <div class="data-div-long">
              <p class="data-title">Total Funding Authorized in 2500-8</p>
              <p class="data-info">${{totalFunding | number: '1.0-0'}}</p>
            </div>
            <div class="data-div">
              <p class="data-title">Report date</p>
              <p class="data-info">{{report().created_on | date:"MM/dd/yyyy"}}</p>
            </div>
          </div>
        }
      </mat-card>
      <mat-card>
        <div class="title">1b. Prepared by</div>
        <div class="bar">&nbsp;</div>
        <div class="whole-line">
          <mat-form-field appearance="outline" class="short-field">
            <mat-label>Name</mat-label>
            <input matInput formControlName="prepared_name" required aria-label="Fire or Complex Name">
            <mat-error>Required Field</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="short-field">
            <mat-label>Email address</mat-label>
            <input matInput formControlName="prepared_address" required aria-label="Fire or Complex Name"
              pattern="[a-zA-Z0-9._%+\-]+&#64;[a-z0-9.\-]+\.[a-z]{2,3}$">
              @if (form.value.prepared_address == '') {
                <mat-error>Required Field</mat-error>
              }
              @if (form.value.prepared_address != '') {
                <mat-error>Please enter a valid
                email</mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="short-field">
              <mat-label>Phone number</mat-label>
              <input matInput formControlName="prepared_number" required aria-label="Fire or Complex Name"
                placeholder="(XXX) XXX-XXXX" mask="(000) 000-0000">
                <mat-error>Required Field</mat-error>
              </mat-form-field>
            </div>
          </mat-card>
        </main>